interface QuappSplashProps {
  /** Quapp icon to show centered (the app's own logo). */
  iconSrc?: string
}

/**
 * Branded launch splash: the Quapp's icon centered on a white background,
 * with a very subtle "powered by Quapp" mark pinned to the bottom
 * (à la "from Meta" on WhatsApp/Instagram). Fills its parent.
 */
export function QuappSplash({ iconSrc }: QuappSplashProps) {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center bg-white">
      <div className="flex flex-1 flex-col items-center justify-center">
        {iconSrc && (
          <img
            src={iconSrc}
            alt=""
            className="h-24 w-24 rounded-[22px] shadow-sm animate-pulse-soft"
            onError={(e) => {
              ;(e.currentTarget as HTMLImageElement).style.visibility = 'hidden'
            }}
          />
        )}
        <div className="mt-8 h-6 w-6 animate-spin rounded-full border-2 border-slate-200 border-t-slate-400" />
      </div>
      <div className="flex items-center gap-1.5 pb-10 opacity-40">
        <span className="text-[11px] tracking-wide text-slate-400">powered by</span>
        <img src="/quapp.png" alt="Quapp" className="h-3.5 grayscale" />
      </div>
    </div>
  )
}
